/**
 * Slide-in overlay panels: cart drawer, search overlay, facets and the variant selector.
 *
 * All four used to build the same gsap timeline (fade the root, fade the backdrop, slide
 * the content in from the right, run a callback on the way out). That pulled a 30KB
 * library into every page for four transitions the compositor can run on its own, so the
 * motion now lives in CSS (.overlay-panel* in base.css) and this module only toggles the
 * class and reports when the closing transition is over.
 */
(function () {
  var SHOWN_CLASS = 'is-shown';
  // Longer than the 500ms transition: it only ever fires when the transition does not.
  var CLOSE_FALLBACK_MS = 700;

  function partsOf(parts) {
    return [parts.root, parts.bg, parts.content].filter(function (element, index, all) {
      // The variant selector passes the same node as root and content.
      return element && all.indexOf(element) === index;
    });
  }

  function open(parts, onStart) {
    var elements = partsOf(parts);
    if (!elements.length) return;

    if (onStart) onStart();

    elements.forEach(function (element) {
      element.classList.remove(SHOWN_CLASS);
    });
    // Reading layout commits the closed state, so the class added next transitions
    // instead of landing in the same frame and showing the panel already open.
    void elements[0].offsetWidth;
    elements.forEach(function (element) {
      element.classList.add(SHOWN_CLASS);
    });
  }

  function close(parts, onEnd) {
    var elements = partsOf(parts);
    if (!elements.length) return;

    elements.forEach(function (element) {
      element.classList.remove(SHOWN_CLASS);
    });

    if (!onEnd) return;

    var target = parts.content || parts.root;
    var settled = false;

    function finish() {
      if (settled) return;
      settled = true;
      target.removeEventListener('transitionend', onTransitionEnd);
      onEnd();
    }

    function onTransitionEnd(event) {
      if (event.target === target) finish();
    }

    target.addEventListener('transitionend', onTransitionEnd);
    // Without this the panel would stay half closed, and the body scroll lock with it,
    // whenever the transition never runs: a hidden tab, or reduced motion.
    setTimeout(finish, CLOSE_FALLBACK_MS);
  }

  window.OGKicksOverlay = { open: open, close: close };
})();
